var React = require('react');

function FavoriteBorder (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.25 7.5C36.9 7.5 32.725 9.525 30 12.725C27.275 9.525 23.1 7.5 18.75 7.5C11.05 7.5 5 13.55 5 21.25C5 30.7 13.5 38.4 26.375 50.1L30 53.375L33.625 50.075C46.5 38.4 55 30.7 55 21.25C55 13.55 48.95 7.5 41.25 7.5ZM30.25 46.375L30 46.625L29.75 46.375C17.85 35.6 10 28.475 10 21.25C10 16.25 13.75 12.5 18.75 12.5C22.6 12.5 26.35 14.975 27.675 18.4H32.35C33.65 14.975 37.4 12.5 41.25 12.5C46.25 12.5 50 16.25 50 21.25C50 28.475 42.15 35.6 30.25 46.375Z","fill":"#00933F"}));
}

FavoriteBorder.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = FavoriteBorder;

FavoriteBorder.default = FavoriteBorder;
